<script setup lang="ts">
import {nextTick, ref} from "vue";
import {ElNotification} from "element-plus";
import {CourseService} from "@/api/api.ts";
import CourseEditForm from "components/dialog/common/innner/CourseEditForm.vue";
import {SaveCourse} from "@/types";

const isShowing = ref(false)
const courseEditForm = ref<InstanceType<typeof CourseEditForm>>()

let courseId = 0

const getCourseBasicInfo = async () => {
  try {
    const res = await CourseService.getCourseBasicInfo({
      id: courseId
    })
    if (res.data.code === 200) {
      if (res.data.data) {
        isShowing.value = true
        await nextTick()
        courseEditForm.value?.init(res.data.data)
      }
    } else {
      ElNotification.error({
        title: "获取信息失败",
        message: res.data.msg,
      })
    }
  } catch (error) {
    console.log(error)
  }
}

const show = (id: number) => {
  courseId = id
  getCourseBasicInfo()
}

const hide = () => {
  isShowing.value = false
  courseEditForm.value?.reset()
}

const emit = defineEmits(["onEditCourse"])

const onEditCourse = async (info: SaveCourse) => {
  emit("onEditCourse", info)
}

defineExpose({
  show, hide
})
</script>

<template>
  <el-dialog @close="hide" v-model="isShowing" title="编辑课程信息" align-center>
    <course-edit-form ref="courseEditForm" @on-edit-course="onEditCourse" />
  </el-dialog>
</template>

<style scoped>
</style>

